module.exports = __webpack_public_path__ + "img/pause.bb96ac92.svg";